var _module_exports ="<!-- Missing file -->\n";;
var path = '/app/Main/selfAccessRequest/arrival/preAuthorized/PreAuthorizedExplanation1.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;